import V3Check from './V3Check'
import { CheckUtils } from 'utils'
import { HelpEmail, MiniNotice, HelpLink } from 'components'
import { Link } from 'react-router'
import { Button } from 'components'
import { Enum } from 'utils'

export default class V3MetaTagsCheck extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  goToPageTypeTemplate() {
    const pageType = localStorage.getItem('pageType').replace('page_type.', '').replace(':', '')

    window.location = Enum.pageTemplates[pageType]
  }

  renderInfo() {
    let metaDescHtml;
    const pageType = localStorage.getItem('pageType').replace(':', '').replace('page_type.', '')

    if(this.context.currentUser.appPlan == 'free') {
      switch(pageType) {
        case "homepage":
           metaDescHtml = (
             <div>
              { this.renderHomepageInstructions() }
             </div>
           )
          break
        case "collection":
          metaDescHtml = (
            <div>
             { this.renderCollectionInstructions() }
            </div>
          )
          break
        case "catalog":
          metaDescHtml = (
            <div>
             { this.renderCatalogInstructions() }
            </div>
          )
          break
        case "page":
          metaDescHtml = (
            <div>
             { this.renderPageInstructions() }
            </div>
          )
          break
        case "product":
          metaDescHtml = (
            <div>
             { this.renderProductInstructions() }
            </div>
          )
          break
        case "blogHome":
          metaDescHtml = (
            <div>
             { this.renderBlogHomeInstructions() }
            </div>
          )
          break
        case "blogPost":
          metaDescHtml = (
            <div>
             { this.renderBlogPostInstructions() }
            </div>
          )
          break
        default:
          metaDescHtml = (
            <div>
             { this.renderOtherInstructions() }
            </div>
          )
          break

      }
    } else {
      metaDescHtml = (
        <div>
          <h3>Add or edit a meta description</h3>
          <p>
            Once Plug in SEO Plus is fully installed in your theme, the app generates meta descriptions automatically from the page content.
          </p>

          <p>
            You can edit your meta descriptions with Plug in SEO's meta description templating tool.
          </p>

          <ol>
            <li>Go to your <Link to="/plus/title-description" target="_blank">Page Title and Meta Descriptions</Link> settings</li>
            <li>Select the relevant page type</li>
            <li>Edit the description template</li>
          </ol>

          <h3>Remove multiple meta descriptions</h3>
          <p>
            If you have multiple meta descriptions or are missing a meta description, you can email us at <HelpEmail /> and we'll help you resolve this problem.
          </p>
        </div>
      )
    }

    return (
      <div>
        <div>
          <h2>Key points</h2>
          <p>
            A pages META description summarises its contents in a couple of sentences.
          </p>
          <p>
            The meta description is the HTML tag &lt;meta name="description" content="meta description text goes here"/&gt; that's located in the &lt;headh&gt; of each page on your site.
          </p>
          <hr />
          <h2>How it's used</h2>
          <ul>
            <li>The META description is shown as the paragraph text in search results</li>
            <li>If you don't include it a search engine will extract one but it may be disjointed and confusing</li>
            <li>Useful for encouraging a click through to your page in search results</li>
            <li>Keywords here that match the user's search are often made bold, encouraging a click through to your page</li>
            <li>Not visible to visitors on the page</li>
            <li>Not used in search engine algorithms</li>
          </ul>
          <hr />
          <h2>Best practice</h2>
          <ul>
            <li>Just one per page</li>
            <li>Every page should either have a unique description (across the website) or it should be omitted</li>
            <li>Two or three sentences describing the page</li>
            <li>Writing copy for humans to entice them to click your result is the focus, weaving keywords in naturally</li>
          </ul>
          <hr />
        </div>
        <div>
          <h2>Fix this yourself</h2>
          {metaDescHtml}
        </div>
      </div>
    )
  }

  metaLiquidHtml() {
    return `
    <!-- meta.liquid snippet  -->
    {% assign maxwords = 30 %}
    {% if template contains 'product' %}
        <meta name="description" content="{{ product.description | strip_html | strip_newlines | truncatewords: maxwords | escape }}" />
    {% elsif template contains 'page' %}
        <meta name="description" content="{{ page.content | strip_html | strip_newlines | truncatewords: maxwords | escape }}" />
    {% elsif template == 'index' %}
        {% if shop.description != '' %}
            <meta name="description" content="{{ shop.description }}" />
        {% endif %}
    {% endif %}`
  }

  snippetHtml() {
    return `
    <!-- snippet reference -->
    <!-- If there's already a meta description like meta name="description", remove it and add this instead -->
    <head>
    ...
    {% include 'meta' %}
    ...
    </head>
    <!-- Don't include the head tags, the comments or the dots (...) --> `
  }

  renderRemoveMultipleMetaDescriptions() {
    const storeThemesURL = 'https://' + this.context.currentUser.shop + '/admin/themes'

    return (
      <div>
        <h3>Remove multiple meta descriptions</h3>
        <MiniNotice
          alert
          header="Coding required"
          note={
            <span>New to coding? <a href="https://support.pluginuseful.com/hc/en-us/articles/23534791516308-A-Guide-to-HTML-Code-Basics" target="blank">Read our guide of HTML code basics</a></span>
          }
        />
        <p>To remove excess page titles you will have to manually edit your theme code.</p>

        <ol>
          <li><a target="_blank" href={storeThemesURL}>View your themes</a> in your Shopify admin</li>
          <li>Select ‘Actions’ and  ‘Edit code’ for your live theme</li>
          <li>Open the theme.liquid file</li>
          <li>Type Control+F (Command+F on a Mac) to open the file search box</li>
          <li>Search for <code>&lt;meta name="description"</code> in the file to find the different titles in your theme</li>
          <li>Decide which title that you’d like to remove</li>
          <li>Add an opening comment tag <code>&#123;% comment %&#125;</code> before the start of the <code>&lt;meta name="description"</code> tag</li>
          <li>Add a closing comment tag <code>&#123;% endcomment %&#125;</code> the end of the same tag <code>/></code> </li>
        </ol>
      </div>
    )
  }

  renderTroubleshooting() {
    return (
      <div>
        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534761896980-Why-does-my-SEO-check-say-that-I-have-multiple-meta-descriptions-but-I-can-only-find-one-in-the-code"
            title="My SEO check says that I have multiple meta descriptions but I can only find one in the code"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534762206996-Why-is-my-SEO-check-still-failing-after-I-added-a-meta-description-in-my-Shopify-settings"
            title="I added a meta description in my Shopify settings and my SEO check still fails"
          />
        </ul>
      </div>
    )
  }

  renderHomepageInstructions() {
    const currentUser = this.context.currentUser
    const storePreferencesURL = 'https://' + currentUser.shop + '/admin/online_store/preferences'
    const storeThemesURL = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <h3>Add or edit your homepage meta description</h3>

        <ol>
          <li>Go to your <a target="_blank" href={storePreferencesURL}>online store > preferences</a> in Shopify</li>
          <li>Add or edit your meta description in the ‘Homepage meta description’ field</li>
        </ol>

        { this.renderRemoveMultipleMetaDescriptions() }

        { this.renderTroubleshooting() }
      </div>
    )
  }

  renderCatalogInstructions() {
    const currentUser = this.context.currentUser
    const storeThemesURL = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        { this.renderRemoveMultipleMetaDescriptions() }

        { this.renderTroubleshooting() }
      </div>
    )
  }

  renderCollectionInstructions() {
    const currentUser = this.context.currentUser
    const storeThemesURL = 'https://' + currentUser.shop + '/admin/themes'
    const collectionsURL = 'https://' + currentUser.shop + '/admin/collections'

    return (
      <div>
        <h3>Add or edit a collection meta description</h3>

        <ol>
          <li>Go to your <a target="_blank" href={collectionsURL}>products > collections</a> in your Shopify admin</li>
          <li>Select the collection missing the meta description</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the collection page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your meta description in the ‘Description’ field</li>
        </ol>

        { this.renderRemoveMultipleMetaDescriptions() }

        { this.renderTroubleshooting() }
      </div>
    )
  }

  renderPageInstructions() {
    const currentUser = this.context.currentUser
    const storeThemesURL = 'https://' + currentUser.shop + '/admin/themes'
    const pagesURL = 'https://' + currentUser.shop + '/admin/pages'

    return (
      <div>
        <h3>Add or edit a page meta description</h3>

        <ol>
          <li><a href={pagesURL} target="_blank" >Go to your online store > pages</a> in your Shopify admin</li>
          <li>Select the page missing the meta description</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your meta description in the ‘Description’ field</li>
        </ol>

        { this.renderRemoveMultipleMetaDescriptions() }

        { this.renderTroubleshooting() }
      </div>
    )
  }

  renderProductInstructions() {
    const currentUser = this.context.currentUser
    const storeThemesURL = 'https://' + currentUser.shop + '/admin/themes'
    const productsURL = 'https://' + currentUser.shop + '/admin/products'

    return (
      <div>
        <h3>Add or edit a product meta description</h3>

        <ol>
          <li>Go to your <a href={productsURL} target="_blank" >products</a> in your Shopify admin</li>
          <li>Select the product missing the meta description</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the product page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your meta description in the ‘Description’ field</li>
        </ol>

        { this.renderRemoveMultipleMetaDescriptions() }

        { this.renderTroubleshooting() }
      </div>
    )
  }

  renderBlogHomeInstructions() {
    const currentUser = this.context.currentUser
    const storeThemesURL = 'https://' + currentUser.shop + '/admin/themes'
    const blogURL = 'https://' + currentUser.shop + '/admin/blogs'

    return (
      <div>
        <h3>Add or edit your blog meta description</h3>

        <ol>
          <li>Go to your <a href={blogURL} target="_blank" >online store > blog posts > manage blogs</a> in your Shopify admin</li>
          <li>Select the relevant blog</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the blog page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your meta description in the ‘Description’ field</li>
        </ol>

        { this.renderRemoveMultipleMetaDescriptions() }

        { this.renderTroubleshooting() }
      </div>
    )
  }

  renderBlogPostInstructions() {
    const currentUser = this.context.currentUser
    const storeThemesURL = 'https://' + currentUser.shop + '/admin/themes'
    const blogPostsURL = 'https://' + currentUser.shop + '/admin/articles'

    return (
      <div>
        <h3>Add or edit a blog post meta description</h3>

        <ol>
          <li>Go to your <a href={blogPostsURL} target="_blank" >online store > blog posts</a> in your Shopify admin</li>
          <li>Select the blog post missing the meta descriptions</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the blog post page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your meta description in the ‘Description’ field</li>
        </ol>

        { this.renderRemoveMultipleMetaDescriptions() }

        { this.renderTroubleshooting() }
      </div>
    )
  }

  renderOtherInstructions() {

    return (
      <div>
        { this.renderRemoveMultipleMetaDescriptions() }

        { this.renderTroubleshooting() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3MetaTagsCheck.js